import { render } from "./ConfirmWaitApproveCenterForm.vue?vue&type=template&id=0c043c7f"
import script from "./ConfirmWaitApproveCenterForm.vue?vue&type=script&lang=js"
export * from "./ConfirmWaitApproveCenterForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__